import React from 'react';
import styled from 'styled-components';
import { Text } from '@oneaudi/unified-web-components';
import { useServicesContext } from '../../../../context';
import { useFormattedPrice } from '../../../../hooks';
import { SYS_SPACE_FIXED_300 } from '@oneaudi/unified-web-common';
const ParameterItem = styled.div `
  margin-bottom: ${(props) => (props.isLast ? '0' : SYS_SPACE_FIXED_300)};
`;
export const FinanceLayerParameter = ({ parameter, isLast, }) => {
    const { audiMarketContextService, getConfiguration } = useServicesContext();
    const currency = getConfiguration().currency ||
        (audiMarketContextService === null || audiMarketContextService === void 0 ? void 0 : audiMarketContextService.getContextItem('nemo.locale.currency'));
    const isCurrency = parameter.unit === currency;
    const formattedValue = isCurrency
        ? useFormattedPrice(parameter.formattedValue || '', parameter.unitSymbol || '', parameter.unit || '')
        : `${parameter.formattedValue || ''} ${parameter.unit || ''}`;
    return (React.createElement(ParameterItem, { isLast: isLast },
        React.createElement(Text, { tag: "p", variant: {
                order: '2',
                style: 'bold',
                type: 'copy',
            } },
            parameter.label,
            " ",
            !!parameter.note && React.createElement(React.Fragment, null, parameter.note)),
        React.createElement(Text, { tag: "p", variant: {
                order: '1',
                style: 'normal',
                type: 'copy',
            } }, formattedValue)));
};
